import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import QualityAppLoader from './helpers/QualityAppLoader';
import qualityIcon from 'static/assets/icons/branding/quality_icon.svg';
import useFavicon from 'hooks/useFavicon';
import { FirestoreUserRole } from '../../generated/graphql';
import BaseLayout from './helpers/BaseLayout';
import { appRoutes } from 'app/routes/constants';
import { useSubdomain } from "hooks/useSubdomain";
import { useOrgNavigate } from "app/routes/useOrgNavigate";

type Props = {
    roles?: FirestoreUserRole[];
};

const AppLayout: React.FC<Props> = ({ }) => {
    const navigate = useOrgNavigate();
    const { pathname } = useLocation();
    const { isAppRoot } = useSubdomain();

    useFavicon(qualityIcon);

    useEffect(() => {
        if (pathname === '/') {
            navigate(appRoutes.HOME);
        }
        if (isAppRoot) {
            navigate(appRoutes.AUTH_LOGIN);
        }
    }, [pathname]);

    return (
        <QualityAppLoader>
            <BaseLayout sidebar topbar />
        </QualityAppLoader>
    );
};

export default AppLayout;
